import { datadogRum } from '@datadog/browser-rum'
import { scrubRumBeforeSend } from '~/util/datadog-scrubber'

datadogRum.init({
  applicationId: process.env.DATADOG_RUM_APP_ID,
  clientToken: process.env.DATADOG_RUM_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: process.env.DATADOG_RUM_SERVICE_NAME,
  env: process.env.DATADOG_ENV_NAME,

  // Specify a version number to identify the deployed version of your application in Datadog
  version: '1.0.0',
  sampleRate: 100,
  premiumSampleRate: 100,
  trackInteractions: true,

  // Enable session replay only in production
  sessionReplaySampleRate: process.env.NODE_ENV === 'production' ? 100 : 0,

  // Enable default privacy settings for session replay (only applies when sessionReplaySampleRate > 0)
  defaultPrivacyLevel: 'mask-user-input',
  // Strip URL query strings (prefilled form iframes carry member PII there)
  // and scrub error text.
  beforeSend: scrubRumBeforeSend,
})
